export default __webpack_public_path__ + "static/media/project3.c4ce464b.PNG";